import { api } from '../lib/api';

/**
 * Upload an image to MinIO storage
 * @param file - The image file to upload
 * @param folder - The folder path (e.g., 'posts', 'events', 'profiles')
 * @returns The public URL of the uploaded image
 */
export const uploadImage = async (file: File, folder: string): Promise<string> => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('folder', folder);

  const response = await api.post<{ url: string }>('/images/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.url;
};
